import type { RemoteRuntimeConfig } from "@shared/host/shell-runtime";
import {
  appConfig,
  getAccountingRemoteUrl,
  getAdminModuleRemoteUrl,
  getHumanResourcesRemoteUrl,
  getInvoiceRemoteUrl,
  getLocalesBaseUrl,
  getTimeTrackingRemoteUrl,
} from "../../lib/config";

const remoteRuntimeResolvers: Record<
  string,
  () => Omit<RemoteRuntimeConfig, "key" | "route">
> = {
  "time-tracking": () => ({
    assets: {
      remoteEntryUrl: getTimeTrackingRemoteUrl(),
      localesBaseUrl: getLocalesBaseUrl(getTimeTrackingRemoteUrl()),
    },
    features: {
      notificationsDomain: "time-tracking",
      exposesSidebarController: true,
    },
  }),
  admin: () => ({
    assets: {
      remoteEntryUrl: getAdminModuleRemoteUrl(),
      localesBaseUrl: getLocalesBaseUrl(getAdminModuleRemoteUrl()),
    },
  }),
  "human-resources": () => ({
    assets: {
      remoteEntryUrl: getHumanResourcesRemoteUrl(),
      localesBaseUrl: getLocalesBaseUrl(getHumanResourcesRemoteUrl()),
    },
    features: {
      notificationsDomain: "human-resources",
      exposesSidebarController: true,
    },
  }),
  invoice: () => ({
    assets: {
      remoteEntryUrl: getInvoiceRemoteUrl(),
      localesBaseUrl: getLocalesBaseUrl(getInvoiceRemoteUrl()),
    },
  }),
  accounting: () => ({
    assets: {
      remoteEntryUrl: getAccountingRemoteUrl(),
      localesBaseUrl: getLocalesBaseUrl(getAccountingRemoteUrl()),
    },
  }),
};

export const resolveShellRemoteRuntimeConfigs = (): RemoteRuntimeConfig[] =>
  Object.entries(appConfig.remotes).map(([key, definition]) => {
    const resolvedRuntimeConfig = remoteRuntimeResolvers[key]?.();

    return {
      key,
      route: definition.route,
      assets: resolvedRuntimeConfig?.assets,
      features: definition.isolationMode
        ? {
            ...resolvedRuntimeConfig?.features,
            isolationMode: definition.isolationMode,
          }
        : resolvedRuntimeConfig?.features,
    };
  });
